export type { YardTaskDetails, YardTaskEventPayload } from './yardTaskPresenterV2Shared';

export { useYardTaskFetcherV2 } from './useYardTaskFetcherV2';
export type { UseYardTaskFetcherV2Options } from './useYardTaskFetcherV2';
export type { UseYardTaskFetcherV2Options as UseYardTaskPresenterV2Options } from './useYardTaskFetcherV2';

export { useYardTaskDisplayV2 } from './useYardTaskDisplayV2';
export type {
  YardTaskDisplayField,
  YardTaskDisplayV2Data,
  UseYardTaskDisplayV2Options
} from './useYardTaskDisplayV2';

import { useYardTaskFetcherV2 } from './useYardTaskFetcherV2';

import type { UseYardTaskFetcherV2Options } from './useYardTaskFetcherV2';

/**
 * Combined fetch + live-update composable. Delegates to {@link useYardTaskFetcherV2}.
 * Pair with {@link useYardTaskDisplayV2} when fetch is owned by a parent (e.g. list row).
 */
export function useYardTaskPresenterV2(options: UseYardTaskFetcherV2Options) {
  return useYardTaskFetcherV2(options);
}

/**
 * TODO: (welington) consolidate/deduplicate the useYardTaskFetcher, useYardTaskPresenter, useYardTask (will be tackled on OD-3238)
 */
